import * as React from "react";
import { ServerPaginatedTable } from "../../../shared";
import { Stack, Box, Chip } from "@mui/material";
import { Link } from "react-router-dom";
import optInPic from "../../../assets/images/Icons/ic_tick_filled_blue.svg";
import optOutPic from "../../../assets/images/Icons/ic_cancel-opt-out.svg";
import useReviewAndRatings from "../hooks/useReviewAndRatings";
import ReviewListFilterSection from "./ReviewListFilterSection";
import InputControl from "../../../shared/components/InputControl";

export const PendingReviewList = () => {
  const {
    handleReviewFilterSelection,
    handleClearAllFilter,
    handleClearFilter,
    handleDateChangeApply,
    handleOpenDateRangeSelection,
    handleAutocompleteServerSearch,
    gotoPage,
    setPageSize,
    handleApplyFilter,
    handleSortBy,
    handleTableSearch,
    handleProductFetch,
    handleProductSearchClear,
    state,
    publishedStatus,
  } = useReviewAndRatings({
    defaultFilter: {
      status: "0",
    },
    table: "pendingReviewsList",
  });

  const ActionButtons = ({ row }) => {
    return (
      <div className="action-buttons">
        <Link to={"review/" + row.id}>
          <img alt="details" src="/icons/arrow_forward.svg" />
        </Link>
      </div>
    );
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Review ID",
        accessor: "id",
      },
      {
        Header: "Customer Name ",
        accessor: "customer_name",
      },
      {
        Header: "Submitted Date & Time",
        accessor: "submitted_date",
      },
      {
        Header: "Rating",
        accessor: "rating",
        Cell: ({ row }) => {
          return (
            <Stack direction="row" gap="4px" height="16px">
              <img alt="star" src="/icons/star-yellow.svg" />
              {row.original.rating}
            </Stack>
          );
        },
      },
      {
        Header: "Product",
        accessor: "product_name",
      },
      {
        Header: "Status",
        accessor: "status",
        disableSortBy: true,
        Cell: ({ value }) => {
          const label =
            value === 0 ? "Pending" : value === 1 ? "Approved" : "Rejected";
          const color =
            value === 0 ? "#C07302" : value === 1 ? "#0F875B" : "#C42B1C";
          const backgroundColor =
            value === 0 ? "#FFF4CE" : value === 1 ? "#E1FBF2" : "#FFE7E3";
          return (
            <Chip
              label={label}
              variant="filled"
              size="small"
              sx={{
                color,
                backgroundColor,
              }}
            />
          );
        },
      },
      {
        Header: "Publish Status",
        accessor: "published_status",
        align: "center",
        Cell: ({ row }) => {
          return (
            <Box
              mr="20px"
              component="img"
              src={row.original.published_status ? optInPic : optOutPic}
              alt={"published_status-" + row.original.id}
            />
          );
        },
      },
      {
        Header: "Action",
        id: "action",
        align: "right",
        disableSortBy: true,
        accessor: (row, index) => {
          return <ActionButtons key={index} row={row} />;
        },
      },
    ],
    []
  );

  return (
    <ServerPaginatedTable
      columns={columns}
      data={state.review.list}
      isLoading={state.review.isLoading}
      gotoPage={gotoPage}
      searchBar={true}
      defaultSearch={false}
      handleSort={handleSortBy}
      setPageSize={setPageSize}
      pagination={state.review.pagination}
      sortByGlobal={state.review.sortBy}
      filterContent={
        <React.Fragment>
          <InputControl
            type="table-search"
            name="search"
            value={state.review.search}
            onChange={handleTableSearch}
            onClear={() => handleTableSearch({ target: { value: "" } })}
          />
        </React.Fragment>
      }
      filterApplied={state.filter.appliedFilters}
      onAllFilterClear={handleClearAllFilter}
      onFilterClear={handleClearFilter}
      filterSection={
        <ReviewListFilterSection
          {...{
            state,
            ratingsList: state.rating.options,
            publishedStatusList: publishedStatus,
            productsList: state.product.options,
            handleReviewFilterSelection,
            handleOpenDateRangeSelection,
            handleDateChangeApply,
            handleApplyFilter,
            handleAutocompleteServerSearch,
            handleProductFetch,
            handleProductSearchClear,
          }}
        />
      }
      onRowLink={(row) => "review/" + row.id}
    />
  );
};
